<template>
  <div
    class="toggle-switch"
    tabindex="0"
    @keyup.space="toggleVal(nextValue)"
  >
    <div
      class="toggle-switch__wrapper rounded-pill"
      ref="wrapper"
    >
      <div
        class="toggle-switch__selected-bg primary rounded-pill"
        :style="selecteStyle"
      ></div>
      <v-sheet
        v-for="({ value, title }, index) in items"
        :key="index"
        :ref="`item-${index}`"
        rounded="pill"
        :class="value === selected ? 'text--secondary' : 'text--primary'"
        @click.prevent="toggleVal(value)"
      >
        {{ title }}
      </v-sheet>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    value: {
      type: [String, Boolean, Number],
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selecteStyle: {}
    }
  },
  computed: {
    selected () {
      return this.value
    },
    selectedIndex () {
      return this.items.findIndex(({ value }) => value === this.selected)
    },
    nextValue () {
      return this.items[this.selectedIndex == this.items.length - 1 ? 0 : this.selectedIndex + 1].value
    }
  },
  watch: {
    selectedIndex () {
      this.setSelectedStyle()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setSelectedStyle()
    })
  },
  methods: {
    toggleVal (value) {
      this.$emit('input', value)
    },
    setSelectedStyle () {
      const firstItem = this.$refs['item-0'][0].$el
      const baseLeft = firstItem.getBoundingClientRect().left
      const item = this.$refs[`item-${this.selectedIndex}`]
      if (item) {
        const elem = item[0].$el
        const left = elem.getBoundingClientRect().left - baseLeft
        this.selecteStyle = {
          width: `${elem.clientWidth}px`,
          left: `${left + 2}px`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/scss/mixins.scss";

  .toggle-switch {
    border-radius: 9999px;
    cursor: pointer;
    display: inline-block;
    position: relative;
    outline: none;

    &::after {
      content: "";
      position: absolute;
      border: solid 1px transparent;
      @include -inset-2;
    }

    &__wrapper {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: 2px;
      position: relative;
    }

    ::v-deep .v-sheet {
      @include label-1;
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      padding: 0 16px;
      position: relative;
      z-index: 1;
      transition: color 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }

    &__selected {
      &-bg {
        height: 32px;
        pointer-events: none;
        position: absolute;
        left: 2px;
        top: 2px;
        z-index: 0;
        transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
      }
    }
  }
</style>
